import React, { useEffect } from "react";
import "./detailpage.scss";
import Dropdown from "react-bootstrap/Dropdown";
import Header from "../landing/Header/Header";
import Footer from "../landing/footer/Footer";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Loader from "../../utils/loader";
import { Link } from "react-router-dom";
import useDetailPage from "../../hooks/useDetailPage";
import { CAT_NAME } from "../../utils/constant";
import ResponsiveImage from "../common/ResponsiveImage";
import Skeleton from "react-loading-skeleton";

const Detailpage = () => {
  const {
    post,
    posts,
    loading,
    tableOfContents,
    contentRef,
    contentId,
    scrollToHeading,
    singleBlog,
  } = useDetailPage({ blogCount: 3 });

  const setBreadcrumbValue = post?.title?.rendered;

  console.log("cbybdycbd", setBreadcrumbValue);

  console.log("Post Image ", post?.content?.rendered);

  console.log("Post", post);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://tomi.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: { setBreadcrumbValue },
        item: "https://tomi.com/",
      },
    ],
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!setBreadcrumbValue) return;

    document.title = `${setBreadcrumbValue} - tomi`;

    const metaDescription = document.querySelector("meta[name='description']");
    const descriptionContent = `Visit the tomi website to read about ${setBreadcrumbValue}.`;

    if (metaDescription) {
      metaDescription.setAttribute("content", descriptionContent);
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.setAttribute("content", descriptionContent);
      document.head.appendChild(newMeta);
    }
  }, [setBreadcrumbValue]);

  const cleanHTML = post?.content?.rendered.replace(
    /<img([^>]+)data-src="([^"]+)"([^>]*)>/g,
    '<img$1src="$2"$3>'
  );

  return (
    <>
      {/* {loading && <Loader />} */}
      <section className="maindetail">
        <Header />
        <img
          src="/assets/bolgbottomshade.png"
          alt="img"
          className="img-fluid bottomshade"
        />
        <div className="custom-container">
          {loading ? (
            <>
              {" "}
              <div className="parentcontent">
                <div className="left" style={{ maxWidth: "198px" }}>
                  <h2 className="upperhead">
                    <Skeleton width={150} />
                  </h2>
                  <div className="bottomcontent" style={{ width: "100%" }}>
                    {[...Array(8)].map((_, i) => (
                      <Skeleton
                        key={i}
                        height={20}
                        width="100%"
                        style={{ marginBottom: 10 }}
                      />
                    ))}
                  </div>
                  <p className="share">
                    <Skeleton width="100%" />
                  </p>
                  <div className="socialimages">
                    {[...Array(4)].map((_, i) => (
                      <Skeleton key={i} width="100%" height={40} circle />
                    ))}
                  </div>
                  <div className="formobileview d-none">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <Skeleton width="100%" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="bottomcontent">
                          {[...Array(8)].map((_, i) => (
                            <Skeleton
                              key={i}
                              height={20}
                              width="100%"
                              style={{ marginBottom: 10 }}
                            />
                          ))}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <div className="buttonmblview d-none">
                  <div className="parentmblmbl">
                    <p className="parambl">
                      <Skeleton width="100%" />
                    </p>
                    <div className="socila">
                      {[...Array(4)].map((_, i) => (
                        <Skeleton key={i} width="100%" height={40} circle />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="right" style={{ flex: 1 }}>
                  <a>
                    <Skeleton width="100%" />
                    <Skeleton width="100%" />
                    <Skeleton width="100%" />
                  </a>
                  <h2 className="mainphead">
                    <Skeleton width="100%" />
                  </h2>
                  <p className="mainpara">
                    <Skeleton count={3} />
                  </p>
                  <h6>
                    <Skeleton width="100%" /> <span>·</span>{" "}
                    <Skeleton width="100%" />
                  </h6>
                  <div className="detailimage">
                    <Skeleton height={250} />
                  </div>

                  <h3 className="mainheading">
                    <Skeleton width="60%" />
                  </h3>
                  <p className="bottompara">
                    <Skeleton count={4} />
                  </p>
                  <ul>
                    {[...Array(3)].map((_, i) => (
                      <li key={i}>
                        <Skeleton width="100%" />
                      </li>
                    ))}
                  </ul>
                  <h3 className="mainheading">
                    <Skeleton width="60%" />
                  </h3>
                  <p className="bottompara">
                    <Skeleton count={4} />
                  </p>
                  <ul>
                    {[...Array(5)].map((_, i) => (
                      <li key={i}>
                        <Skeleton width="100%" />
                      </li>
                    ))}
                  </ul>
                  <h3 className="mainheading">
                    <Skeleton width="60%" />
                  </h3>
                  <p className="bottompara">
                    <Skeleton count={3} />
                  </p>
                  <p className="bottompara1">
                    <Skeleton width="50%" />
                  </p>
                </div>
              </div>{" "}
            </>
          ) : (
            <>
              <div className="parentcontent">
                <div className="left">
                  {tableOfContents === null || tableOfContents === undefined ? (
                    <>
                      <h2 className="upperhead">
                        <Skeleton width={150} />
                      </h2>
                      <div className="bottomcontent" style={{ width: "100%" }}>
                        {[...Array(8)].map((_, i) => (
                          <Skeleton
                            key={i}
                            height={20}
                            width="100%"
                            style={{ marginBottom: 10 }}
                          />
                        ))}
                      </div>
                    </>
                  ) : tableOfContents.length > 0 ? (
                    <>
                      <h2 className="upperhead">Table of Contents</h2>
                      <div className="bottomcontent">
                        {tableOfContents.map((item) => (
                          <a
                            key={item.id}
                            href={`#${item.id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              scrollToHeading(item.id);
                            }}
                            className={
                              contentId === item.id
                                ? "gray active text-truncate"
                                : "gray text-truncate"
                            }
                            style={{ marginLeft: `${(item.level - 2) * 10}px` }}
                          >
                            {item.text.slice(0, 35)}
                          </a>
                        ))}
                      </div>
                    </>
                  ) : (
                    <>
                      <h2 className="upperhead">Table of Contents</h2>
                      <div className="bottomcontent">
                        <a
                          className="gray"
                          style={{
                            whiteSpace: "nowrap",
                            pointerEvents: "none",
                          }}
                        >
                          No Data Found!
                        </a>
                      </div>
                    </>
                  )}
                </div>
                <div className="right">
                  <Breadcrumb className="breadcrumbprnt">
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href="/blog">Blog</Breadcrumb.Item>
                    <Breadcrumb.Item className="breadvrumbcntactive text-truncate w-50">
                      {post?.title?.rendered}
                    </Breadcrumb.Item>
                  </Breadcrumb>

                  <h2 className="mainphead">{post?.title?.rendered}</h2>
                  <div
                    className="mainpara"
                    dangerouslySetInnerHTML={{
                      __html: post?.excerpt?.rendered,
                    }}
                  />
                  <h6>
                    {post?.uagb_author_info?.display_name} <span>·</span>
                    {new Date(post?.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </h6>

                  {/* Image is there */}
                  <div className="detailimage">
                    <img
                      src={post?.uagb_featured_image_src?.full[0]}
                      alt={post?.title?.rendered}
                      className="img-fluid innerimg"
                    />
                  </div>

                  {/* The issue Identified here */}

                  {/* 
                  <div
                    ref={contentRef}
                    className="detailpage_contentdynamic"
                    dangerouslySetInnerHTML={{
                      __html: post?.content?.rendered,
                    }}
                  ></div> */}

                  {/* SO the issue was React just injects the HTML and data-src was unknow thats why it wasnt working */}
                  <div
                    ref={contentRef}
                    className="detailpage_contentdynamic"
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML, // 	Replace data-src with src manually in HTML
                    }}
                  ></div>
                </div>
              </div>
            </>
          )}
        </div>
      </section>

      <section className="stayupdate">
        <div className="custom-container">
          <div className="parentupper">
            <h2 className="upperhead ">Stay up to date</h2>
            <Link to="/blog " className="secondarybtn">
              See All
            </Link>
          </div>
          <div className="maincards">
            {posts.length > 0
              ? posts.map((post) => (
                  <p
                    onClick={() => singleBlog(post.slug)}
                    key={post.id}
                    className="innercard"
                  >
                    <div className="innercardinner">
                      <div className="mainimage">
                        <ResponsiveImage
                          post={post}
                          className="img-fluid innerimg"
                        />
                      </div>
                      <button className="blog">
                        {CAT_NAME[post.categories?.[0]]}
                      </button>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: post?.title?.rendered,
                        }}
                      />
                    </div>
                  </p>
                ))
              : !loading && <p>No posts available.</p>}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Detailpage;

// import React from 'react';
// import './detailpage.scss';
// import Dropdown from 'react-bootstrap/Dropdown';
// import Header from '../landing/Header/Header';
// import Footer from '../landing/footer/Footer';
// import { useEffect, useState, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import Breadcrumb from 'react-bootstrap/Breadcrumb';
// import Loader from '../../utils/loader';
// import { ApiUrl } from '../../utils/Api';
// import { CAT_NAME } from '../../utils/constant';

// const Detailpage = () => {
//     const { id, idTwo } = useParams();
//     const [post, setPost] = useState(null);
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(false);
//     const contentRef = useRef(null);
//     const [tableOfContents, setTableOfContents] = useState([]);
//     const [contentId,setContentId] =useState()
//     const [posts, setPosts] = useState([]);

//     useEffect(() => {
//         const fetchPost = async (slug) => {
//             try {
//                 setLoading(true)
//                 const response = await fetch(
//                     `${ApiUrl}posts?slug=${slug}`
//                 );
//                 const data = await response.json();

//                 if (data.length > 0) {
//                     setPost(data[0]);
//                     window.scroll(0, 0)
//                 } else {
//                     setPost(null);
//                 }
//             } catch (error) {
//                 console.error('Error fetching post:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchPost(id);
//     }, [id]);
//     function name() {
//         const headings = contentRef?.current?.querySelectorAll('h2, h3, h4, h5, h6');
//         console.log(11111, 'hello');

//         if (headings && headings.length > 0) {
//             const toc = Array.from(headings).map((heading) => {
//                 const extractText = (node) => {
//                     let text = "";
//                     for (const childNode of node.childNodes) {
//                         if (childNode.nodeType === Node.TEXT_NODE) {
//                             text += childNode.textContent;
//                         } else if (childNode.nodeType === Node.ELEMENT_NODE) {
//                             text += extractText(childNode); // Recursive call
//                         }
//                     }
//                     return text;
//                 };

//                 const text = extractText(heading).trim();

//                 return {
//                     id: heading.id || `toc-${Math.random().toString(36).substring(2, 11)}`,
//                     text: text,
//                     level: parseInt(heading.tagName.substring(1)),
//                 };
//             });

//             headings.forEach((heading, index) => {
//                 if (!heading.id) {
//                     heading.id = toc[index].id;
//                 }
//             });

//             setTableOfContents(toc);
//         }
//     }
//     // function name() {
//     //     const headings = contentRef?.current?.querySelectorAll(' h2, h3, h4, h5, h6,b');
//     //     console.log(11111, 'hello')
//     //     if (headings.length > 0) { // check if headings are found
//     //         const toc = Array.from(headings).map((heading) => ({
//     //             id: heading.id || `toc-${Math.random().toString(36).substring(2, 11)}`,
//     //             text: heading.textContent,
//     //             level: parseInt(heading.tagName.substring(1)),
//     //         }));

//     //         headings.forEach((heading, index) => {
//     //             if (!heading.id) {
//     //                 heading.id = toc[index].id;
//     //             }
//     //         });

//     //         setTableOfContents(toc);
//     //     }
//     // }
//     useEffect(() => {
//         if (post  && post.content.rendered) {
//           setTimeout(() => {
//               name()
//           }, 1000);
//         }
//     }, [post, contentRef?.current, post?.content?.rendered]);
//     // useEffect(() => {
//     //     if (post && contentRef.current && post.content.rendered) {
//     //         const headings = contentRef.current.querySelectorAll('h2, h3, h4, h5, h6, b, strong');
//     //         const toc = Array.from(headings).map((heading) => ({
//     //             id: heading.id || `toc-${Math.random().toString(36).substring(2, 11)}`, // Corrected substring usage
//     //             text: heading.textContent,
//     //             level: parseInt(heading.tagName.substring(1)),
//     //         }));

//     //         headings.forEach((heading, index) => {
//     //             if (!heading.id) {
//     //                 heading.id = toc[index].id;
//     //             }
//     //         });

//     //         setTableOfContents(toc);
//     //     }
//     // }, [post, post?.content?.rendered]);

//     const scrollToHeading = (id) => {
//         const element = document.getElementById(id);
//         if (element) {
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//         setContentId(id)
//     };

//     console.log(idTwo, 'contentId');
//     const fetchPosts = async (categoryId = null) => {
//         // setLoading(true);
//         try {
//             const categoryFilter = categoryId ? `&categories=${categoryId}` : '';
//             const response = await fetch(`${ApiUrl}posts?per_page=3&page=${1}${categoryFilter}`);
//             if (!response.ok) {
//                 throw new Error("Failed to fetch posts");
//             }

//             const data = await response.json();
//                 setPosts(data);

//         } catch (error) {
//             // setError(error.message);
//         } finally {
//             // setLoading(false);
//         }
//     };

//     useEffect(() => {
//         let realId;
//         if (idTwo !== 'null'){
//             fetchPosts(idTwo);
//         }else{
//             fetchPosts();
//         }

//     }, [idTwo]);
//     function singleBlog(slug) {
//         // to = {`/blogdetail/${post.slug}/${idTwo ? idTwo : 'null'}`
//         window.scroll(0,0)
//        navigate(`/blogdetail/${slug}/${idTwo ? idTwo : 'null'}`)
// }

//     return (
//         <>
//             {loading && <Loader/>}
//             <section className="maindetail">
//                 <Header />
//                 <img
//                     src="/assets/bolgbottomshade.png"
//                     alt="img"
//                     className="img-fluid bottomshade"
//                 />
//                 <div className="custom-container">
//                     <div className="parentcontent">
//                         <div className="left">
//                             {tableOfContents?.length > 0 &&<>
//                             <h2 className="upperhead">Table of Contents</h2>
//                             <div className="bottomcontent">
//                                 {tableOfContents?.map((item) => (
//                                     <a
//                                         key={item.id}
//                                         href={`#${item?.id}`}
//                                         onClick={(e) => {
//                                             e.preventDefault();
//                                             scrollToHeading(item?.id);
//                                         }}
//                                         className={contentId === item?.id ? "gray active text-truncate" : "gray text-truncate"}
//                                         style={{ marginLeft: `${(item?.level - 2) * 10}px` }}
//                                     >
//                                         {item.text?.slice(0,35)}
//                                     </a>
//                                 ))}
//                             </div>
//                             </>}
//                             {/* <p className="share">Share on</p>
//                             <div className="socialimages">
//                                 <img src="/assets/twitter.png" alt="img" className="img-fluid" />
//                                 <img src="/assets/link.png" alt="img" className="img-fluid" />
//                                 <img src="/assets/fb.png" alt="img" className="img-fluid" />
//                                 <img src="/assets/mail.png" alt="img" className="img-fluid" />
//                             </div> */}
//                             {tableOfContents?.length > 0 &&  <div className="formobileview d-none">
//                                 <Dropdown>
//                                     <Dropdown.Toggle id="dropdown-basic">
//                                         Table of Contents
//                                         <svg
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             width="22"
//                                             height="22"
//                                             viewBox="0 0 22 22"
//                                             fill="none"
//                                         >
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
//                                                                                         <path fill-rule="evenodd" clip-rule="evenodd" d="M5.87151 7.87874L5.50027 7.50751L4.75781 8.24997L5.12904 8.6212L10.629 14.1212L11.0003 14.4924L11.3715 14.1212L11.9084 13.5843L11.187 12.8208L11.0003 13.0075L5.87151 7.87874ZM11.8874 12.1203L13.1808 12.3119L16.8715 8.6212L17.2427 8.24997L16.5003 7.50751L16.129 7.87874L11.8874 12.1203Z" fill="#0E1120" />
//                                                                                     </svg>
//                                         </svg>
//                                     </Dropdown.Toggle>

//                                     <Dropdown.Menu>
//                                         <div className="bottomcontent">
//                                             {tableOfContents.map((item) => (
//                                                 <a
//                                                     key={item.id}
//                                                     href={`#${item.id}`}
//                                                     onClick={(e) => {
//                                                         e.preventDefault();
//                                                         scrollToHeading(item.id);
//                                                     }}
//                                                     className="gray text-truncate"
//                                                     style={{ marginLeft: `${(item.level - 2) * 10}px` }}
//                                                 >
//                                                     {item.text?.slice(0, 40)}
//                                                 </a>
//                                             ))}
//                                         </div>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>}
//                         </div>
//                         {/* ... (rest of the left section) */}
//                         <div className="right">

//                 <Breadcrumb className='breadcrumbprnt'>
//                   <Breadcrumb.Item className='breadvrumbcnt' href="#">Home</Breadcrumb.Item>

//                   <Breadcrumb.Item className='breadvrumbcnt' href="#">Blog</Breadcrumb.Item>
//                                 <Breadcrumb.Item className='breadvrumbcntactive text-truncate w-50' href="#">{post?.title?.rendered}</Breadcrumb.Item>
//                 </Breadcrumb>
//                             <h2 className="mainphead">{post?.title?.rendered}</h2>
//                             <div
//                                 className="mainpara"
//                                 dangerouslySetInnerHTML={{ __html: post?.excerpt?.rendered }}
//                             />
//                             <h6>
//                                 {post?.uagb_author_info?.display_name} <span>·</span>
//                                 {new Date(post?.date)?.toLocaleDateString('en-US', {
//                                     year: 'numeric',
//                                     month: 'short',
//                                     day: 'numeric',
//                                 })}
//                             </h6>
//                             <div className="detailimage">
//                                 <img
//                                     src={post?.uagb_featured_image_src?.full[0]}
//                                     alt={post?.title?.rendered}
//                                     className="img-fluid innerimg"
//                                 />
//                             </div>
//                             <div
//                                 ref={contentRef}
//                                 className="detailpage_contentdynamic"
//                                 dangerouslySetInnerHTML={{ __html: post?.content?.rendered }}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <section className='stayupdate'>
//                              <div className='custom-container'>
//                                  <div className='parentupper'>
//                                      <h2 className='upperhead'>Stay up to date</h2>
//                         <Link to='/blog'>See All</Link>
//                                  </div>
//                                  <div className='maincards'>

//                         {posts?.length > 0 ? (
//                             posts?.map((post, id) => (
//                                 <p onClick={() => singleBlog(post?.slug)} key={post?.id}  className='innercard'>
//                                     <div className='innercardinner'>
//                                         <div className='mainimage'>
//                                             <img src={post?.uagb_featured_image_src?.medium[0] || '/assets/Image2?.png'}
//                                                 alt={post?.title?.rendered} className='img-fluid innerimg' />
//                                         </div>
//                                         <button className='blog'>{CAT_NAME[post?.categories?.[0]] }</button>
//                                         <p dangerouslySetInnerHTML={{ __html: post?.title?.rendered }} />
//                                     </div>
//                                 </p>
//                             ))
//                         ) : (
//                             !loading && <p>No posts available.</p>
//                         )}
//                                  </div>
//                              </div>
//                          </section>
//             <Footer />
//         </>
//     );
// };

// export default Detailpage;
